import { getRequest } from '../services/requestHandler';
import { HeadWeightNumberAftDto } from '../models';

export const getHeadWeightNumberAft = async () => {
  const url = 'HeadWeight/GetHeadWeightNumbersAft';
  const response = await getRequest<HeadWeightNumberAftDto>('GetHeadWeightNumbersAft', url);
  // TODO: Remove this from here and implement uuid when API is available
  let autoId = 0;
  let numbers = response.map((r) => {
    return { ...r, headWeightNumberAftId: autoId++ };
  });
  return numbers;
};
